<template>
  <Popup :mobile="mobile" no-close-button>
    <div class="d-flex align-items-center justify-content-center h-100">
      <div class="post-menu-wrapper">
        <div class="post-menu-container">
          <template v-if="isActiveUserPost">
            <b-button class="destructive" variant="light" @click="onOptionSelected('delete-post')">Delete</b-button>
<!--            Disable for now-->
<!--            <b-button variant="light" @click="onOptionSelected('edit-post')">Edit</b-button>-->
          </template>
          <template v-else>
            <b-button class="destructive" variant="light" @click="onOptionSelected('report-post')">Report</b-button>
            <template v-if="userInfo.blockedByMe">
              <b-button variant="light" @click="onOptionSelected('unblock-user')">Unblock</b-button>
            </template>
            <template v-else>
              <b-button class="destructive"  variant="light" @click="onOptionSelected('block-user')">Block</b-button>
              <template v-if="!userInfo.userBlockedMe">
                <b-button v-if="userInfo.followedByMe" class="destructive" variant="light"
                          @click="onOptionSelected('unfollow-user')">Unfollow</b-button>
                <b-button v-else variant="light" @click="onOptionSelected('follow-user')">Follow</b-button>
              </template>
            </template>
          </template>
          <b-button :class="mobile ? '':'last-button'" variant="light" @click="closePopup">Cancel</b-button>
        </div>
      </div>
    </div>
  </Popup>
</template>
<script>
import Popup from "@/module_social/components/Popup";
import {createNamespacedHelpers} from "vuex";
import postMixins from "@/module_social/mixins/postMixins";
const {
  mapActions: postActions,
  mapGetters: postGetters,
} = createNamespacedHelpers("social");

export default {
  mixins: [postMixins],
  components: {
    Popup
  },
  props: {
    post: {
      type: Object, default: null, deep: true
    },
    mobile: {
      type: Boolean, default: false
    }
  },
  computed: {
    ...postGetters(['socialUserInfo']),

    isActiveUserPost() {
      const activeUserId = this.socialUserInfo && this.socialUserInfo.userId;
      const postUserId = this.userInfo.userId;
      return activeUserId && postUserId && activeUserId === postUserId;
    }
  },
  methods: {
    closePopup() {
      this.$emit("closePopup");
    },
    onOptionSelected(actionType) {
      this.$emit('selectedOption', actionType);
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/style/_social.scss";

.post-menu-wrapper {
  border-radius: $border-radius;
  max-height: calc(100vh - 40px);
  max-width: $max-width-mobile-post-menu;
  min-width: $min-width-mobile-post-menu;
  flex-grow: 1;
}

.post-menu-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 100%;

  align-items: stretch;
  justify-content: center;
  position: relative;
  vertical-align: baseline;

  .btn {
    border-top: 1px solid $post-separator;
    border-radius: 0;
    font-weight: 600;
    cursor: pointer;
    font-size: $font-size-4x;
    min-height: $dim-6x;

    &:first-child {
      border-top: none;
      border-radius: $border-radius $border-radius 0 0;
    }
  }

  .last-button {
    border-bottom: none;
    border-radius: 0 0 $border-radius $border-radius;
  }

  .destructive {
    color: $destructive-color;
  }
}
</style>